import React from 'react';

const CategorySkeleton = () => (
  <div className="group relative overflow-hidden rounded-xl shadow-lg bg-white h-[300px] animate-pulse">
    <div className="aspect-square bg-gray-200">
      <div className="absolute inset-0 bg-gradient-to-t from-gray-300 to-transparent" />
    </div>
    <div className="absolute bottom-0 left-0 right-0 p-6">
      <div className="h-6 w-24 bg-gray-300 rounded mb-2"></div>
      <div className="space-y-2">
        <div className="h-4 w-20 bg-gray-300 rounded"></div>
        <div className="h-4 w-24 bg-gray-300 rounded"></div>
        <div className="h-4 w-16 bg-gray-300 rounded"></div>
      </div>
    </div>
  </div>
);

export default CategorySkeleton;